import React from "react";
import "./WhatsappLoader.css"; // Import external CSS

const WhatsappLoader = ({ text = "Processing..." }) => {
  return (
    <div className="whatsapp-loader-overlay">
      <div className="whatsapp-loader"></div>
      <p className="whatsapp-loader-text">{text}</p>
    </div>
  );
};

export default WhatsappLoader;
